import type { FilterPanelCheckItem } from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import Group from 'components/utils/Group'
import { FormattedMessage } from 'react-intl'
import type { IntlShape } from 'react-intl'

export function getCruisePromotionLabel(intl: IntlShape, promotionName: string): string {
  switch (promotionName) {
    case 'Lux Exclusive':
      return intl.formatMessage({
        id: 'DYuqoo-0R-K75EiCvsed',
        defaultMessage: 'Lux Exclusive',
        description: 'Cruise promotions filter option label for Luxury Escapes exclusive cruise offers',
      })
    case 'Special offers':
      return intl.formatMessage({
        id: '85JVt5unXMsAXLthOoHJ',
        defaultMessage: 'Special offers',
        description: 'Cruise promotions filter option label for special cruise offers in search filters',
      })
    default:
      return promotionName
  }
}

export function buildCruisePromotionPanelCheckItems(
  facets: Array<App.CruiseSearchFacet>,
  intl: IntlShape,
  searchString?: string,
): Array<FilterPanelCheckItem> {
  const items = facets.filter(facet => facet.count)

  if (items.length === 0) return []

  return items.map((item): FilterPanelCheckItem => ({
    value: item.name,
    hidden: !!(
      searchString &&
      facets.length > 5 &&
      !getCruisePromotionLabel(intl, item.name).toLowerCase().includes(searchString)
    ),
    label: (
      <Group direction="horizontal" horizontalAlign="space-between">
        {getCruisePromotionLabel(intl, item.name)}
        <span><FormattedMessage
          id="xBnOGlXTC1jrjoxmyhsR"
          defaultMessage="({count})"
          description="Count of matching cruise offers for a promotion filter option"
          values={{ count: item.count }}
        />
        </span>
      </Group>
    ),
  }))
}
